import React, { useState, useEffect, useCallback } from "react";
import axiosConfig from "../Service/axiosConfig"
import Modal from 'react-bootstrap/Modal';
import { NavLink, useSearchParams } from "react-router-dom";
import { PostDP, Navbar, FormParser } from "../Components";
import Masters from "../Components/masters.json"
import { ExploreGrid } from "./exploregrid";
import { useURLParams } from "../Components/UrlUtils/useURLParams"
import { FaTimes } from 'react-icons/fa';
import useDebouncedValue from "../Utils/Debounce";
import { useScrollContext } from "../Utils/ScrollContext";
import { useSearch } from "../Utils/SearchContext";
const SearchProducts = () => {
    const { setParam, getParam, getMultiSelectParam, handleMultiSelect } = useURLParams();
    const { registerLoadMore } = useScrollContext();
    const [searchParams, setSearchParams] = useSearchParams()
    const [Data, setData] = useState([])
    const [loading, setLoading] = useState("")
    const [loading2, setLoading2] = useState("")
     const { query, setQuery } = useSearch();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1020);
    const [filterShow, setFilterShow] = useState(false)
    const [totalPages, settotalPages] = useState()
    const [initialformData, setinitialFormData] = useState({});
    const [nextUrl, setNextUrl] = useState(null);
    const [count, setCount] = useState("")
    const [formData, setformData] = useState({
        department: getParam('department') || "",
        project_type: getParam('project_type') || "",
        role: getMultiSelectParam('role'),
        categories: getParam('categories') || "",
        skills: getParam('skills') || "",
        present_state: getParam('present_state') || "",
        present_city: getParam('present_city') || "",
        languages: getMultiSelectParam('languages'),
        gender: getParam('gender') || "",
        from_age: getParam('from_age') || "",
        to_age: getParam('to_age') || "",
        from_height: getParam('from_height') || "",
        to_height: getParam('to_height') || "",
        no_picture: getParam('no_picture') || "",
        is_pro: getParam('is_pro') || "",
        ordering: getParam('ordering') || ""
    })
    const generateQueryString = (data) => {
        const queryStringParts = Object.entries(data)
            .filter(([_, value]) => value && (Array.isArray(value) ? value.length > 0 : true)) // Filter out empty values
            .map(([key, value]) =>
                `${encodeURIComponent(key)}=${encodeURIComponent(Array.isArray(value) ? value.join(',') : value)}`
            );
        return queryStringParts.join('&');
    };
    let page = 1;
    const debouncedSearchTerm = useDebouncedValue(query, 500);
    const handleInputChangeDebounced = (event) => {
        const newQuery = event.target.value;
        setQuery(newQuery);
        const updatedData = { ...formData, search_query: newQuery };
        setSearchParams(generateQueryString(updatedData));
    };
    const formSubmit = (Data) => {
        setFilterShow(false);
        const updatedData = { ...Data, search_query: query };
        setformData(Data);
        setSearchParams(generateQueryString(updatedData));
    };
    const HandleSort = (e) => {
        const { name, value } = e.target;
        const updatedData = { ...formData, search_query: query, [name]: value };
        const dataStore = { ...formData, [name]: value }
        setformData(dataStore);
        setSearchParams(generateQueryString(updatedData));
    };
    const handleResize = () => {
        setIsMobile(window.innerWidth < 1020);
    };
    const generateArrayQueryString = (key, array) => {
        return array && array.length > 0
            ? array.map(item => `${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`).join('&')
            : '';
    };
    const constructApiParams = (page) => {
        const existingParams = window.location.search; 
        const additionalParams = `page_size=20&page=${page}`;

        return existingParams ? `${existingParams}&${additionalParams}` : `?${additionalParams}`;
    };
    const GetData = async () => {
        setLoading(true);

        const roleQueryString = generateArrayQueryString('role', formData.role);
        const languagesQueryString = generateArrayQueryString('languages', formData.languages);
        const apiParams = constructApiParams(page);
        let url = `/accounts/user-profiles/${apiParams}${roleQueryString ? `&${roleQueryString}` : ''}${languagesQueryString ? `&${languagesQueryString}` : ''}`
        try {
            const response = await axiosConfig.get(url);

            setCount(response.data.count);
            setNextUrl(response.data.next);
            setData(response.data.results);
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleInfiniteScroll = async () => {
        try {
            if (
                window.innerHeight + document.documentElement.scrollTop + 200 >=
                document.documentElement.scrollHeight
            ) {
                if (!nextUrl || loading2) return;

                setLoading2(true);
                const apiPath = nextUrl
                  .replace("https://api.indiacastingclub.com", "")
                  .replace("https://api.hyderabadcastingclub.com", "");

                const resp = await axiosConfig.get(apiPath);
                setData(prev => [...prev, ...resp.data.results]);
                setNextUrl(resp.data.next); 
                setLoading2(false);
            }
        } catch (error) {
            console.log(error);
            setLoading2(false);
        }
    };

    const loadFormDataFromURL = () => {
        setLoading(true);
        setinitialFormData(formData);
        setLoading(false);
    };
    useEffect(() => {
        GetData();
        loadFormDataFromURL();
    }, [formData, debouncedSearchTerm])
    useEffect(() => {
        registerLoadMore(handleInfiniteScroll);
        return () => registerLoadMore(null);
    }, [handleInfiniteScroll, registerLoadMore, nextUrl, loading2]);


    const handleRemove = (key, itemToRemove = null) => {
        setformData((prevFormData) => {
            const newFormData = { ...prevFormData };
            if (Array.isArray(newFormData[key])) {
                newFormData[key] = newFormData[key].filter((item) => item !== itemToRemove);
            } else if (key === "query") {
                setQuery("")
            } else {
                newFormData[key] = '';
            }
            formSubmit(newFormData)
            return newFormData;
        });
    };

    return (
        <>
            <div className="search-screen-container search-page" style={{ overflow: "hidden" }}>
                <div className="content-area" style={{ position: "relative" }}>
                    <div className="container-position filter_button_down" style={{
                        position: "sticky",
                        top: "-25px",
                        background: "#ffff",
                    }}>
                        <div class="inlineContainer">
                            <div className="sort-content">
                                <select className="Selectbar" id="sortby" name="ordering" onChange={HandleSort} value={formData.ordering}>
                                    <option value="">Sort By</option>
                                    <option value="id">Fisrt to Last</option>
                                    <option value="-id">Last to First</option>
                                    <option value="user__first_name">Name (A to Z)</option>
                                    <option value="-user__first_name">Name (Z to A)</option>
                                </select>
                            </div>
                            <div class="inlineHeader">
                                <div className="view-btn filter-btn" onClick={() => setFilterShow(true)}><img src={require("./images/filtersearch.png")} alt="" />Filters ({count})</div>
                            </div>
                            <div className="inlinBpContainer">
                                {Object.entries(formData).map(([key, value], index) =>
                                    Array.isArray(value) && value.length > 0 ? (
                                        value.map((item, itemIndex) => (
                                            <button key={`${index}-${itemIndex}`} className="btn btn-shortlist shortlist-icon">
                                                <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 0 }}>
                                                    <b>{`${key}: ${item}`}</b>
                                                    <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                        <FaTimes size={18} onClick={() => handleRemove(key, item)} />
                                                    </span>
                                                </p>
                                            </button>
                                        ))
                                    ) : !Array.isArray(value) && value ? (
                                        <button key={index} className="btn btn-shortlist shortlist-icon">
                                            <p style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: 0 }}>
                                                <b>{`${key}: ${value}`}</b>
                                                <span style={{ marginLeft: '8px', cursor: 'pointer' }}>
                                                    <FaTimes size={18} onClick={() => handleRemove(key)} />
                                                </span>
                                            </p>
                                        </button>
                                    ) : null
                                )}
                            </div>
                        </div>
                    </div>
                    <ExploreGrid Data={Data} loading={loading} loading2={loading2} />
                </div>
            </div >
            <Modal
                show={filterShow}
                onHide={() => setFilterShow(false)}
                aria-labelledby="example-modal-sizes-title-sm"
                className="mobile-filter-pop modal-responsive"
            >
                <Modal.Body className="">
                    <button variant="primary" className="btn btn-default close-btn" onClick={() => setFilterShow(false)}>
                        X
                    </button>
                    <FormParser modelObject={Masters.FilterForm} formData={initialformData} formSubmit={formSubmit} />
                </Modal.Body>
            </Modal>
        </>
    )
}
export { SearchProducts };